import React, { useState } from "react";
import { Container, Modal, Form, Button } from "react-bootstrap";
import ReactPlayer from "react-player";
import "./plan.css";
import ReactReadMoreReadLess from "react-read-more-read-less";
import "react-datepicker/dist/react-datepicker.css";
import AdditionalInfo from "./additional-info";
import OrderSummeryOrderCheckout from "./order-summery-order-checkout";
import SignUp from "./sign-up";
import Payment from "./payment";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import PaymentSuccess from "./payment-success-order-checkout";
import LoadingOverlay from "react-loading-overlay";
import { Buffer } from "buffer";
import { TviWLogo, Facebook, Google, EmailIcon } from "../../assets/images";
import Vid from "../../assets/video/file.mp4";
import { useSelector, useDispatch } from "react-redux";
import { changeStep, setCode } from "../../actions/signUp.actions";
import { payments } from "../../actions/payment.actions";
import { useEffect } from "react";
import { getTokenDetails } from "../../axios/payment.axios";
import BlankOrderSummery from "./blank-order-summery";
import OrderCheckoutSignUp from "./order-checkout-sign-up";
import { getPrice ,getPriceForVipProduct,codeIsValidCheckAndDetails} from "../../axios/payment.axios";
import SuccessEscapeBucks from "./success-escape-buck";

const OrderCheckoutPart = () => {
  let affiliateCode = new URLSearchParams(window.location.search).get("encode");
  const [showSummary, setShowSummary] = useState(false);
  const [showSummaryBlank, setShowSummaryBlank] = useState(true);
  const product = useSelector((state) => state.product.details);
  const dispatch = useDispatch();
  const [couponLoader, setCouponLoader] = useState(false);
  const [validClass, setValidClass] = useState("");

  const [loader, setLoader] = useState(false);

  const currentForm = useSelector((state) => state.changeStep);
  const getForm = (forname) => {
    dispatch(changeStep(forname));
  };
  const showHideLoader = (status) => {
    setLoader(status);
  };
  const changeCouponLoader = (status) => {
    setCouponLoader(status);
  };
  const handleCoupon = async (coupon) => {
    try {
      showHideLoader(true);

      if (!coupon) {
        showHideLoader(false);
        NotificationManager.error("No Coupon given");
        return 0;
      }
      if(product && product.isisEscapeBuckPlan == false){
      let details = await getTokenDetails(coupon, product.price_id).catch(
        (err) => {
          showHideLoader(false);
          NotificationManager.error(err);
        }
      );
      let newPrice;

      if (details) {
        if (details.amount_off) {
          newPrice = product.initialPrice - parseInt(details.amount_off / 100);

          if (isNaN(newPrice)) {
            newPrice = 0;
          }
        } else
          newPrice =
            product.initialPrice -
            parseInt(
              (parseInt(product.initialPrice) * details.percent_off) / 100
            );
        if (isNaN(newPrice)) {
          newPrice = 0;
        }
        dispatch(payments.setPrice(newPrice));
        showHideLoader(false);
        NotificationManager.success("Coupon applied");

        dispatch(payments.setCoupon(details.id));
        setValidClass("valid");
      } else {
        dispatch(payments.setPrice(product.initialPrice));
        dispatch(payments.setCoupon(undefined));
        setValidClass("invalid");
      }
    }else{
      let detail = await codeIsValidCheckAndDetails(coupon,product.product_id).then((res) => {
        showHideLoader(false);
        console.log(res,"ddd")
        if(res.status){
          dispatch(payments.setCoupon(res.data.code));
          setValidClass("valid");
          NotificationManager.success("CareFi code applied");
        }else{
          setValidClass("invalid");
          NotificationManager.error("Invalid CareFi code");
          dispatch(payments.setCoupon(undefined));
        }
      })
    }
    } catch (error) {
      showHideLoader(false);
      NotificationManager.error(error);
      setValidClass("invalid");
      dispatch(payments.setCoupon(undefined));
    }
  };
  const handleClick = (message, status) => {
    if (status) NotificationManager.success(message);
    else {
      NotificationManager.error(message);
    }
  };
  useEffect(() => {
    getForm("signUp");

    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message; // For most browsers
      return message; // For some older browsers
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    if (affiliateCode) {
      dispatch(setCode(Buffer.from(affiliateCode, "base64").toString("utf-8")));
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const setProduct = async (event) => {
    setLoader(true);
    console.log(
      event.target[event.target.selectedIndex].getAttribute("data-price"),event.target.value
    );
    event.preventDefault();
    let prodId = event.target[event.target.selectedIndex].getAttribute("data-product_id");
    let price_id =
      event.target[event.target.selectedIndex].getAttribute("data-price");
      let data_product_type_escape = event.target[event.target.selectedIndex].getAttribute("data-product-type");
      console.log(prodId,"data_product_type_escape")
      if(data_product_type_escape == "false"){

        getPrice(price_id)
          .then((response) => {
            let name =
              event.target[event.target.selectedIndex].getAttribute("data-name");
            let product_id =
              event.target[event.target.selectedIndex].getAttribute("data-name");
    
            let product = {
              product_id,
              name,
              price: response.data,
              price_id,
              initialPrice: response.data,
              priceObject: response.metadata,
              isEscapeBuckPlan:false,
              isVip:true
            };
            //   console.log(product,"product")
            dispatch(payments.setProduct(product));
            //   window.open("/check-out")
    
            // history.push("/check-out")
            setShowSummary(true);
            setLoader(false);
          })
          .catch((err) => {
            setLoader(false);
            NotificationManager.error("Something went wrong");
          });
      }else{
        getPriceForVipProduct(prodId)
        .then((response) => {
          console.log(response.data.name,"vip response")
          let product = {
            product_id:response.data._id,
            name: response.data.name,
            price: parseInt(response.data.price),
            price_id:response.data._id,
            initialPrice: parseInt(response.data.price),
            priceObject: response.data,
            isEscapeBuckPlan:true,
            isVip:true
          };
          //   console.log(product,"product")
          dispatch(payments.setProduct(product));
            //   window.open("/check-out")
    
            // history.push("/check-out")
            setShowSummary(true);
            setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          NotificationManager.error("Something went wrong");
        });
      }
  };
  useEffect(() => {
    // Only set this state if the form is "success"
    if (currentForm.formWizard === "success" || currentForm.formWizard === "escapebuckSuccess") {
      setShowSummaryBlank(false);
    } else {
      setShowSummaryBlank(true);
    }
  }, [currentForm.formWizard]);

  const getWizard = () => {
    switch (currentForm.formWizard) {
      case "signUp":
        return (
          <OrderCheckoutSignUp
            setProduct={setProduct}
            changeWizard={getForm}
            notify={handleClick}
            loader={showHideLoader}
          />
        );

      case "aInfo":
        return (
          <AdditionalInfo
            changeWizard={getForm}
            notify={handleClick}
            loader={showHideLoader}
          />
        );

      case "payment":
        return (
          <Payment
            changeWizard={getForm}
            notify={handleClick}
            loader={showHideLoader}
          />
        );

      case "final":
        return (
          <Payment
            changeWizard={getForm}
            notify={handleClick}
            loader={showHideLoader}
          />
        );

      case "success":
        return (
          <PaymentSuccess
            changeWizard={getForm}
            notify={handleClick}
            loader={showHideLoader}
            summary={setShowSummary}
            ShowSummaryBlank={setShowSummaryBlank}
          />
        );
      case "escapebuckSuccess":
        return (
          <SuccessEscapeBucks
            changeWizard={getForm}
            notify={handleClick}
            loader={showHideLoader}
            summary={setShowSummary}
            ShowSummaryBlank={setShowSummaryBlank}
          />
        );

      default:
        break;
    }
  };

  return (
    <div>
      <div className="plan_parts">
        <div className="video_bg1 plan_bg_box">
          <ReactPlayer
            width={"100%"}
            height="100%"
            url={Vid}
            playing={true}
            muted={true}
            loop
          />
        </div>
        <div className="loves_travel">
          <Container>
            <div className="loves_travel_inner">
              <h2>EVERYONE LOVES TRAVEL.</h2>
              <div className="tvi_w_logo">
                <img src={TviWLogo} alt="" />
              </div>
              <div className="trip_membership">
                <LoadingOverlay active={loader} spinner text="Loading...">
                  <div className="check_out_partts">
                    <h2>Checkout</h2>
                    {console.log(showSummaryBlank, showSummary, "fffffffff")}
                    <div className="sign_order">
                      {getWizard()}
                      {showSummaryBlank ? (
                        showSummary ? (
                          <OrderSummeryOrderCheckout
                            validClass={validClass}
                            product={product}
                            handleApply={handleCoupon}
                            handleLoader={changeCouponLoader}
                          />
                        ) : (
                          <BlankOrderSummery />
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </LoadingOverlay>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default OrderCheckoutPart;
